export default __webpack_public_path__ + "images/b113431832f78ea5a0c2eaef94ffbe41-equifax.svg";